import React, { Fragment, memo, useContext } from 'react'

import logoutIcon from '../../../assets/icons/logout.svg'
import { Backdrop } from '../../../components/common'
import { useToggle } from '../../../components/CustomHooks/useCustomHooks'
import { LanguageContext } from '../../../context/LanguageContext'

const AccountInfo = ({ userDetails, logout }) => {
    const { rtl, strings } = useContext(LanguageContext)

    const [showAccountInfo, setShowAccountInfo] = useToggle(false)
    if (!userDetails) {
        return null
    }

    const { email } = userDetails

    return (
        <Fragment>
            <div
                className={`toolbar--actions accountIcon ${showAccountInfo && 'underline'} ${
                    rtl ? 'rtl' : 'ltr'
                }`}
            >
                <span className={'userIcon'} onClick={setShowAccountInfo}>
                    {email.substring(0, 3)}
                </span>
            </div>
            {showAccountInfo && (
                <div className={`account_outer ${rtl ? 'rtl' : 'ltr'}`}>
                    <div className={'account_info'}>
                        <div className={'account_info__userIcon'}>{email.substring(0, 3)}</div>
                        <div className={'account_info__details'}>
                            <div className={'email'}>{email}</div>
                        </div>
                        <div className={'account_info__logout'} onClick={logout}>
                            <img
                                src={logoutIcon}
                                alt={'logout'}
                                className={'account_info__logout__icon'}
                            />
                            <span className={'account_info__logout__text'}>
                                {strings.HEADER_LOG_OUT}
                            </span>
                        </div>
                    </div>
                </div>
            )}
            {showAccountInfo && <Backdrop closeBackdrop={setShowAccountInfo} />}
        </Fragment>
    )
}

export default memo(AccountInfo)
